import { useGetImage } from "./customHooks";
import { typeOfProducts } from "../shared/ProductClassification/type-of-products";
import { useGetImages } from "../hooks/use-get-images";

export default function ProductImage(props) {
  const { offer } = props;

  return <HandleImage offer={offer} />;
}
function HandleImage({ offer }) {
  if (offer.vehicle?.images?.length >= 1) {
    return <ImageByProductImages images={offer.vehicle.images} />;
  }
  if (offer.vehicle?.image) {
    return <ImageByProduct offer={offer} />;
  }
  if (offer.vehicle?.category?.image) {
    return <ImageByCategory offer={offer} />;
  }
  if (offer.vehicle?.category?.typeId) {
    return <ImageByProductType offer={offer} />;
  }
}

function ImageByProduct({ offer }) {
  const productImage = useGetImage(offer.vehicle?.image);
  return (
    <img
      src={productImage}
      alt=""
      //   onLoad={() => setLoading(false)}
      style={{
        height: "100%",
        width: "100%",
        objectFit: "scale-down",
      }}
    />
  );
}

function ImageByCategory({ offer }) {
  const { imagePath: categoryImage } = useGetImages(
    offer.vehicle?.category?.image
  );
  return (
    <img
      src={categoryImage}
      alt=""
      //   onLoad={() => setLoading(false)}
      style={{
        height: "100%",
        width: "100%",
        objectFit: "contain",
      }}
    />
  );
}

function ImageByProductType({ offer }) {
  const defaultImage = typeOfProducts[0]?.image;
  const productTypeImage = typeOfProducts?.find(
    (productType) => productType.id === offer.vehicle?.category?.typeId
  )?.image;
  return (
    <img
      src={productTypeImage ?? defaultImage}
      alt=""
      //   onLoad={() => setLoading(false)}
      style={{
        height: "100%",
        width: "100%",
        objectFit: "contain",
      }}
    />
  );
}

function ImageByProductImages({ images }) {
  const { imagePath, loading } = useGetImages(images[0]);

  return (
    <img
      src={imagePath}
      alt=""
      style={{
        height: "100%",
        width: "100%",
        objectFit: "contain",
        display: loading ? "none" : "block",
      }}
    />
  );
}
